<div fxLayout="row" fxLayoutGap="10">
  <div fxLayout="column" fxLayoutGap="8">
    <div fxFlex fxLayout="row" fxLayoutGap="8">
      <button
        fxFlex
        mat-raised-button
        ngClass.gt-sm="btn-sm"
        ngClass.gt-md="btn-md"
        ngClass.gt-lg="btn-lg"
        (click)="goToPaymentTypes()">
        Tipos de Pagamento
      </button>

      <button
        fxFlex
        mat-raised-button
        ngClass.gt-sm="btn-sm"
        ngClass.gt-md="btn-md"
        ngClass.gt-lg="btn-lg"
        (click)="goToGlobalConfig()">
        Configurações Globais
      </button>
    </div>
    <div fxFlex fxLayout="row" fxLayoutGap="8">
      <button
        fxFlex
        mat-raised-button
        ngClass.gt-sm="btn-sm"
        ngClass.gt-md="btn-md"
        ngClass.gt-lg="btn-lg"
        (click)="goToAccountTypes()">
        Tipos de Conta
      </button>
        <button
        fxFlex
        mat-raised-button
        ngClass.gt-sm="btn-sm"
        ngClass.gt-md="btn-md"
        ngClass.gt-lg="btn-lg"
        (click)="goToAccountMovimentations()">
        Movimentação
      </button>
    </div>
     <div fxFlex fxLayout="row" fxLayoutGap="8">
    
    </div>
  </div>
</div>
